import AuthenticationService from '@/services/AuthenticationService';
import ActionService from "@/services/ActionService";
import CustomFilter from '@/plugins/CustomFilter';

export default {
  data() {
    return {
      SurveyRevisionStatus: ActionService.SurveyRevisionStatus
    };
  },

  computed: {
    getRevisionStatusOptions() {
      return [
        { value: this.SurveyRevisionStatus.New, text: this.getRevisionStatusText(this.SurveyRevisionStatus.New) },
        { value: this.SurveyRevisionStatus.Approved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Approved) },
        { value: this.SurveyRevisionStatus.Dismissed, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Dismissed) },
        { value: this.SurveyRevisionStatus.DismissedCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.DismissedCustom1) },
        { value: this.SurveyRevisionStatus.DismissedCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.DismissedCustom2) },
        { value: this.SurveyRevisionStatus.DismissedCustom3, text: this.getRevisionStatusText(this.SurveyRevisionStatus.DismissedCustom3) },
        { value: this.SurveyRevisionStatus.InProgress, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgress) },
        { value: this.SurveyRevisionStatus.InProgressAgency, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgressAgency) },
        { value: this.SurveyRevisionStatus.InProgressCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgressCustom1) },
        { value: this.SurveyRevisionStatus.InProgressCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.InProgressCustom2) },
        { value: this.SurveyRevisionStatus.Recheck, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Recheck) },
        { value: this.SurveyRevisionStatus.Solved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Solved) },
        { value: this.SurveyRevisionStatus.Revised, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Revised) },
        { value: this.SurveyRevisionStatus.RevisedApprovedGoodwill, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedGoodwill) },
        { value: this.SurveyRevisionStatus.RevisedApprovedCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedCustom1) },
        { value: this.SurveyRevisionStatus.RevisedApprovedCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedCustom2) },
        { value: this.SurveyRevisionStatus.RevisedApprovedCustom3, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApprovedCustom3) },
        { value: this.SurveyRevisionStatus.RevisedApproved, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedApproved) },
        { value: this.SurveyRevisionStatus.RevisedDismissed, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissed) },
        { value: this.SurveyRevisionStatus.RevisedDismissedCustom1, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissedCustom1) },
        { value: this.SurveyRevisionStatus.RevisedDismissedCustom2, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissedCustom2) },
        { value: this.SurveyRevisionStatus.RevisedDismissedCustom3, text: this.getRevisionStatusText(this.SurveyRevisionStatus.RevisedDismissedCustom3) },
        { value: this.SurveyRevisionStatus.Done, text: this.getRevisionStatusText(this.SurveyRevisionStatus.Done) },
      ];
    },

    notificationSettingsRoute() {
      return this.$router.currentRoute.path.startsWith("/external") ?
        {name: 'ExternalNotificationSettings'} :
        {name: 'Notification settings'};
    },

    revisionInitialStatusId() {
      if (APP_TARGET === "fressnapf")
        return this.SurveyRevisionStatus.InProgressCustom1;
      else
        return this.SurveyRevisionStatus.New;
    }
  },

  methods: {
    msm_timefromnow(value) {
      return CustomFilter.msm_timefromnow(value);
    },

    userHasActionRevisePermission: function() {
      return AuthenticationService.localUserProfile.Permissions.includes('ActionsRevise');
    },

    userHasActionReviseReadOnlyPermission: function() {
      return AuthenticationService.localUserProfile.Permissions.includes('ActionsReviseReadOnly') && !AuthenticationService.isMSMUser;
    },

    getRevisionCreatedText(surveyRevision) {
      let at = surveyRevision.CreatedAt ? this.msm_timefromnow(surveyRevision.CreatedAt) : null;
      let by = surveyRevision.CreatedBy ?
        `${surveyRevision.CreatedBy.FirstName} ${surveyRevision.CreatedBy.LastName}` +
        (surveyRevision.CreatedBy.Email ? ` (${surveyRevision.CreatedBy.Email})` : '')
        : null;

      return this.$t('Webportal.Created') + ' ' + at +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getRevisionLastUpdatedText(surveyRevision) {
      let at = this.msm_timefromnow(surveyRevision.ModifiedAt ? surveyRevision.ModifiedAt : surveyRevision.CreatedAt);
      let by = surveyRevision.ModifiedAt && surveyRevision.ModifiedBy ?
        `${surveyRevision.ModifiedBy.FirstName} ${surveyRevision.ModifiedBy.LastName}` :
        !surveyRevision.ModifiedAt && surveyRevision.CreatedBy ?
          `${surveyRevision.CreatedBy.FirstName} ${surveyRevision.CreatedBy.LastName}` : null;

      return this.$t('Webportal.LastUpdated', { at }) +
        (by ? ' ' + this.$t('Webportal.By', { by }) : '');
    },

    getRevisionStatusText(statusId) {
      switch (statusId) {
        case this.SurveyRevisionStatus.New:
          return this.$t('Webportal.Actions.SurveyRevision.StatusNew');
        case this.SurveyRevisionStatus.Approved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusApproved');
        case this.SurveyRevisionStatus.Dismissed:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissed');
        case this.SurveyRevisionStatus.DismissedCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissedCustom1');
        case this.SurveyRevisionStatus.DismissedCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissedCustom2');
        case this.SurveyRevisionStatus.DismissedCustom3:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDismissedCustom3');
        case this.SurveyRevisionStatus.InProgress:
          return this.$t('Webportal.Actions.SurveyRevision.StatusAcceptedInProgress');
        case this.SurveyRevisionStatus.InProgressAgency:
          return this.$t('Webportal.Actions.SurveyRevision.StatusInProgressAgency');
        case this.SurveyRevisionStatus.InProgressCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusInProgressCustom1');
        case this.SurveyRevisionStatus.InProgressCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusInProgressCustom2');
        case this.SurveyRevisionStatus.Recheck:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRecheck');
        case this.SurveyRevisionStatus.Solved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusSolved');
        case this.SurveyRevisionStatus.Revised:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevised');
        case this.SurveyRevisionStatus.RevisedApprovedGoodwill:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedGoodwill');
        case this.SurveyRevisionStatus.RevisedApprovedCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApprovedCustom1');
        case this.SurveyRevisionStatus.RevisedApprovedCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApprovedCustom2');
        case this.SurveyRevisionStatus.RevisedApprovedCustom3:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApprovedCustom3');
        case this.SurveyRevisionStatus.RevisedApproved:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedApproved');
        case this.SurveyRevisionStatus.RevisedDismissed:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissed');
        case this.SurveyRevisionStatus.RevisedDismissedCustom1:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissedCustom1');
        case this.SurveyRevisionStatus.RevisedDismissedCustom2:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissedCustom2');
        case this.SurveyRevisionStatus.RevisedDismissedCustom3:
          return this.$t('Webportal.Actions.SurveyRevision.StatusRevisedDismissedCustom3');
        case this.SurveyRevisionStatus.Done:
          return this.$t('Webportal.Actions.SurveyRevision.StatusDone');
      }
    },

    getRevisionStatusIcon(statusId) {
      switch (statusId) {
        case this.SurveyRevisionStatus.New:
          return "exclamation-circle";
        case this.SurveyRevisionStatus.Dismissed:
        case this.SurveyRevisionStatus.DismissedCustom1:
        case this.SurveyRevisionStatus.DismissedCustom2:
        case this.SurveyRevisionStatus.DismissedCustom3:
        case this.SurveyRevisionStatus.RevisedDismissed:
        case this.SurveyRevisionStatus.RevisedDismissedCustom1:
        case this.SurveyRevisionStatus.RevisedDismissedCustom2:
        case this.SurveyRevisionStatus.RevisedDismissedCustom3:
          return "times-circle";
        case this.SurveyRevisionStatus.InProgress:
        case this.SurveyRevisionStatus.InProgressAgency:
        case this.SurveyRevisionStatus.InProgressCustom1:
        case this.SurveyRevisionStatus.InProgressCustom2:
        case this.SurveyRevisionStatus.Recheck:
          return "play-circle";
        case this.SurveyRevisionStatus.Approved:
        case this.SurveyRevisionStatus.Solved:
        case this.SurveyRevisionStatus.Revised:
        case this.SurveyRevisionStatus.RevisedApprovedGoodwill:
        case this.SurveyRevisionStatus.RevisedApprovedCustom1:
        case this.SurveyRevisionStatus.RevisedApprovedCustom2:
        case this.SurveyRevisionStatus.RevisedApprovedCustom3:
        case this.SurveyRevisionStatus.RevisedApproved:
          return "check-circle";
        case this.SurveyRevisionStatus.Done:
          return "dot-circle";
        default:
          return "question-circle";
      }
    },

    isSurveyRevisionAllowed(surveyInstance) {
      return surveyInstance.IsVisibleForQuery;
    }
  }
};
